import {createAction, props} from "@ngrx/store";
import {Planet} from "../../models/Planet";

export const UPDATE = '[PlanetList] Update'
export const REFRESH = '[PlanetList] Refresh';
export const update = createAction(UPDATE, props<{ planets: Planet[] }>());
export const refresh = createAction(REFRESH);
